export default __webpack_public_path__ + "maps-examples-camera-animators-thumbnail-480-9218b9f67452a5c5995e88d03060c86a.png";